export default __webpack_public_path__ + "static/teamPhoto3-326ea6109850008e7c9c7aeafd51d01b.png";